import { Injectable } from '@angular/core';
import { PurchasesByPeriodCollectionQuery, PurchasesByPeriodCollectionQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, RootContext, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(PurchasesByPeriodCollectionQuery)
@Wrapper(PurchasesByPeriodCollectionQueryHandlerBase)
export class PurchasesByPeriodCollectionQueryHandler {
    public constructor(
        http: Http,
        rootContext: RootContext
    ) { }
}
